import { useVuelidate } from '@vuelidate/core'
import { required, maxLength, minLength, email, alphaNum } from '@vuelidate/validators'
import { Language } from '@/enums/languages.enum'
import { Modal } from 'bootstrap';
export default {

  setup () {
    return { v$: useVuelidate() }
  },

  data () {
    return {
      criterias: {
        selectedIdentification: '',
        selectedEmail: '',
        selectedEmailConfirmation: '',
        selectedDescription: '',
        selectedRole: '',
        selectedLanguage: '',
        selectedDistributor: '',
        selectedInternal: false
      },
      distributorRefs: [],
      roleIdWithDistributorRef: [],
      managedRoleIds: [],
      responseErr: null,
      isProcessing: false,
      languages: Language,
      showDistributor: false,
      validationError: false
    }
  },

  created () {
    this.init()
  },

  methods: {
    async init () {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('users/initCreateUser', {
        idDistributeur: null
      }).then(
        response => {
          this.distributorRefs = response.distributorRefs
          this.roleIdWithDistributorRef = response.roleIdWithDistributorRef
          this.managedRoleIds = response.managedRoleIds
          this.isProcessing = false
        },
        error => {
          this.distributorRefs = []
          this.roleIdWithDistributorRef = []
          this.managedRoleIds = []
          this.error = true
          this.responseErr = error || 'BAD_REQUEST'
          this.showError(error || 'BAD_REQUEST')
        }
      )
    },

    createUser () {
      this.validationError = this.v$.$invalid

      if (!this.validationError) {
        this.create()
      }
    },

    async create () {
      this.isProcessing = true
      this.responseErr = null
      let successMsg = null

      this.$store.dispatch('users/create', {
        identification: this.criterias.selectedIdentification,
        email: this.criterias.selectedEmail,
        emailConfirmation: this.criterias.selectedEmailConfirmation,
        description: this.criterias.selectedDescription,
        idRole: this.criterias.selectedRole,
        language: this.criterias.selectedLanguage,
        distributorRef: this.criterias.selectedDistributor,
        isInternal: this.criterias.selectedInternal
      }).then(
        () => {
          successMsg = this.$i18n.t('label.user.userCreatedSuccess', [this.criterias.selectedIdentification] )
          this.showSuccess(successMsg)
        },
        error => {
          this.error = true
          this.responseErr = error || 'BAD_REQUEST'
          this.showError(error || 'BAD_REQUEST')
        }
      )
    },

    updateDistributer () {
      if (this.roleIdWithDistributorRef.some(roleId => roleId === this.criterias.selectedRole)) {
        this.showDistributor = true
      } else {
        this.showDistributor = false
        this.criterias.selectedDistributor = ''
      }
    },

    status (validation) {
      return {
        'validation-error': validation.$invalid && this.validationError
      }
    },

    showError (msg) {
      let errorModal = new Modal(document.getElementById('errorModal'))
      errorModal.show()
      document.getElementById('errorModalMsg').innerHTML = this.$i18n.t('error.' + msg)
    },

    showSuccess (msg) {
      let successModal = new Modal(document.getElementById('successModal'))
      successModal.show()
      document.getElementById('successModalMsg').innerHTML = msg
    },

    leavePage () {
      this.$router.push({ name: 'user-list' })
    }
  },

  validations() {
    return {
      criterias: {
        selectedIdentification: { required, alphaNum, minLength: minLength(4), maxLength: maxLength(20) },
        selectedEmail: { required, email },
        selectedEmailConfirmation: {
          required,
          email,
          emailConfirmed () {
            return (
              this.criterias.selectedEmailConfirmation === this.criterias.selectedEmail
            )
          }
        },
        selectedDescription: { maxLength: maxLength(255) },
        selectedRole: {
          required
        },
        selectedLanguage: { required },
        selectedDistributor: {
          requiredConditioned () {
            return (
              (!this.roleIdWithDistributorRef.some(roleId => roleId === this.criterias.selectedRole)) ||
              (this.criterias.selectedDistributor && this.roleIdWithDistributorRef.some(roleId => roleId === this.criterias.selectedRole))
            )
          }
        },
        selectedInternal: { required }
      }
    }
  }
}
